import type { FileVideoUsage } from '@vedalib/editor/lib/files'
import { FileTypeEnum } from 'utils'

import MediaPlayer from 'components/MediaPlayer'
import { useVideoAndAudioUrl } from 'utils/files'

import * as s from './VideoPreview.module.scss'

const VideoPreview = (value: FileVideoUsage) => {
  const mediaUrl = useVideoAndAudioUrl(value)

  return (
    <div className={s.root}>
      {mediaUrl && <MediaPlayer type={FileTypeEnum.VIDEO} url={mediaUrl || null} />}
    </div>
  )
}

export default VideoPreview
